/*******************************************************************************
 * Copyright     : Copyright (c)  2025 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/

import { useState, useCallback } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

//@Models
import { INotificationProps } from '../../../models/softwaredetails';

//@Utils
import { ServiceActions, ServiceKeys } from '../../../utils/constants';

export const useNotificationUtil = () => {
  const flags = useFlags();
  const [showWarningNotification, setShowWarningNotification] = useState<boolean>(false);
  const [notificationProps, setNotificationProps] = useState<INotificationProps>({});

  const evaluateWarningNotification = useCallback((actionKey: string, serviceKey: string) => {
    if (serviceKey === ServiceKeys.NEXT9 && actionKey === ServiceActions.INSTALL && flags.vseAutoLicense) {
      const props: INotificationProps = {
        title: 'License Not Found',
        detailsText: 'Please Enter a Valid License',
        severity: 'error'
      };
      setNotificationProps(props);
      setShowWarningNotification(true);
    } else if (actionKey === ServiceActions.REINSTALL && serviceKey === ServiceKeys.NEXT9) {
      const props: INotificationProps = {
        title: 'Change in License Key',
        detailsText: 'If you are changing License Key, please change in Security Center as well.',
        severity: 'warning'
      };
      setNotificationProps(props);
      setShowWarningNotification(true);
    } else {
      setShowWarningNotification(false);
      setNotificationProps({});
    }
  }, [flags.vseAutoLicense]);

  const resetNotification = useCallback(() => {
    setShowWarningNotification(false);
    setNotificationProps({});
  }, []);

  return {
    showWarningNotification,
    notificationProps,
    evaluateWarningNotification,
    resetNotification
  };
};